<div class="application-settings-dialog">
  @if (isLoad) {
    <div class="p-dialog-content mt-[30px]">
      <p-scrollPanel [style]="{ width: '100%', height: '65vh' }">
        <form [formGroup]="applicationSettingsForm">
          <div formArrayName="result">
            <div
              class="grid grid-cols-3 space-y-2 space-x-2"
              *ngFor="let setting of settingsFormControls; let i = index"
              [formGroupName]="i"
            >
              <div class="flex justify-center items-center">
                <input
                  pInputText
                  class="w-full text-field"
                  formControlName="name"
                />
              </div>

              <div class="flex justify-center items-center">
                <p-inputNumber
                  mode="decimal"
                  [locale]="environment.locale"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  formControlName="value"
                  class="w-full input-field"
                ></p-inputNumber>
              </div>

              <div class="flex justify-center items-center">
                <p-inputNumber
                  mode="decimal"
                  [locale]="environment.locale"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  formControlName="valueDisabled"
                  class="w-full input-field"
                ></p-inputNumber>
              </div>
            </div>
          </div>
          <div class="flex justify-end pt-6"></div>
        </form>
      </p-scrollPanel>
    </div>

    <div class="p-dialog-footer">
      <div class="grid grid-rows-1 grid-cols-2 gap-4">
        <div class="text-left">
          <button pButton (click)="closeDialog()" class="btnCancel">
            {{ "vehicles.dialog.buttons.btnCancel" | transloco }}
          </button>
        </div>
        <div>
          <button
            pButton
            (click)="saveApplicationSettings()"
            class="btnPrimary"
          >
            {{ "applicationSettings.labels.save" | transloco }}
          </button>
        </div>
      </div>
    </div>
  }
</div>
